module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerPlaceHolderForNewExclusiveRevamp) ? _c('div', {
    staticClass: "row exc-cat-card-inner-new",
    on: {
      "click": function($event) {
        _vm.categoryDetails(_vm.value, _vm.value.gender)
      }
    }
  }, [_c('div', {
    staticClass: "pl-2 pt-2 pb-2 pr-0",
    class: _vm.isDesktop ? 'col-6' : ''
  }, [_c('img', {
    staticClass: "Group-11",
    attrs: {
      "src": _vm.value.image,
      "alt": "Image"
    }
  })]), _vm._v(" "), _c('div', {
    class: _vm.isDesktop ? 'col-6' : 'col-7',
    style: (_vm.isDesktop ? 'padding: 0;' : '')
  }, [_c('p', {
    staticClass: "exc-category-name-new text-left pl-1",
    class: _vm.isDesktop ? 'pt-4' : 'pt-3'
  }, [_vm._v(_vm._s(_vm.value.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "exc-text-cat-new pl-1"
  }, [_vm._v(_vm._s(_vm.value.category))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 p-0",
    staticStyle: {
      "background": "#e8e8e8",
      "position": "absolute"
    },
    style: (_vm.isDesktop ? 'top: 46%;left: -0.86%;' : 'top: 45%;left: -0.1%;')
  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 p-0",
    staticStyle: {
      "position": "absolute",
      "left": "-0.1%"
    },
    style: (_vm.isDesktop ? 'bottom: 15%;' : 'bottom: 17%;')
  }, [_c('div', {
    staticClass: "col-6 p-0",
    staticStyle: {
      "border-right": "1px solid #e8e8e8"
    }
  }, [_c('p', {
    staticClass: "exc-regular-value",
    staticStyle: {
      "color": "#122643",
      "font-size": "1.313rem"
    }
  }, [_vm._v("₹" + _vm._s(parseInt(_vm.value.regular_price)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6 p-0"
  }, [_c('p', {
    staticClass: "exc-price-value",
    staticStyle: {
      "font-size": "1.313rem"
    }
  }, [_vm._v("₹" + _vm._s(_vm.value.exclusive_price))]), _vm._v(" "), (_vm.value.regular_price > 0) ? _c('p', {
    staticStyle: {
      "font-size": "0.625rem",
      "font-style": "italic",
      "color": "#148c8d",
      "ont-weight": "normal",
      "font-stretch": "normal"
    }
  }, [_vm._v("Save " + _vm._s(parseInt(((_vm.value.regular_price - _vm.value.exclusive_price) / _vm.value.regular_price) * 100)) + "%")]) : _c('p', {
    staticStyle: {
      "font-size": "0.625rem",
      "font-style": "italic",
      "color": "#148c8d",
      "ont-weight": "normal",
      "font-stretch": "normal"
    }
  }, [_vm._v("Save 0%")])])])])]) : _c('div', {
    staticClass: "exc-cat-card-inner",
    on: {
      "click": function($event) {
        _vm.categoryDetails(_vm.value, _vm.value.gender)
      }
    }
  }, [_c('img', {
    staticClass: "exc-cat-card-img",
    attrs: {
      "src": _vm.value.image,
      "alt": "Image"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "exc-category-name"
  }, [_vm._v(_vm._s(_vm.value.product_name))]), _vm._v(" "), _c('p', {
    staticClass: "exc-regular-title"
  }, [_vm._v("REGULAR PRICE")]), _vm._v(" "), _c('p', {
    staticClass: "exc-regular-value"
  }, [_vm._v("₹ " + _vm._s(_vm.value.regular_price))]), _vm._v(" "), _c('p', {
    staticClass: "exc-price"
  }, [_vm._v("EXCLUSIVE PRICE")]), _vm._v(" "), _c('p', {
    staticClass: "exc-price-value"
  }, [_vm._v("₹ " + _vm._s(_vm.value.exclusive_price))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 p-0 Regular-Price"
  }, [_c('p', [_vm._v("Regular Price")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 p-0 Exclusive-Price"
  }, [_c('p', [_vm._v("Exclusive Price")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f4dc1b3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/excCategoryCard.vue
// module id = 2532
// module chunks = 24